<template>
  <v-list two-line v-bind="$attrs" v-on="$listeners">
    <template v-for="item of listItems">
      <v-list-item :key="item.key ">
        <v-list-item-icon>
          <v-icon>
            {{ item.icon}}
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-subtitle>
            {{ item.title }}
          </v-list-item-subtitle>

          <v-list-item-title>
            {{ item.value }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'UserPersonalInfo',

  inheritAttrs: false,

  props: {
    userData: {
      type: Object,
      required: true,
    },
  },

  computed: {
    listItems: (vm) => [
      {
        key: 'fullname',
        icon: 'mdi-card-account-details',
        title: 'Nome completo',
        value: vm.userData.name,
      },

      {
        key: 'nickname',
        icon: 'mdi-account-question',
        title: 'Como prefere ser chamado',
        value: vm.userData.nickname,
      },

      {
        key: 'username',
        icon: 'mdi-at',
        title: 'Usuário',
        value: vm.userData.username,
      },

      {
        key: 'email',
        icon: 'mdi-email',
        title: 'Email',
        value: vm.userData.email,
      },
    ],
  },
};
</script>
